<template>
  <path
    :d="pathD"
    fill="none"
    :stroke="strokeColour"
    :stroke-width="strokeWidth" />
</template>

<script>
import PartnershipTypes from "@/assets/js/partnership-types";

export default {
  props: [
    "partnership",
    "zone",
    "partner1",
    "partner2",
  ],

  computed: {
    partner1Position() {
      return this.getPositionCentre(this.partner1[0].$refs["icon-container"]);
    },

    partner2Position() {
      return this.getPositionCentre(this.partner2[0].$refs["icon-container"]);
    },

    neighbouringPositions() {
      const pos1 = this.getPositionBox(this.partner1[0]);
      const pos2 = this.getPositionBox(this.partner2[0]);

      const leftNeighbour = pos2.right > pos1.left - pos1.width && pos2.right < pos1.left;
      const rightNeighbour = pos2.left > pos1.right && pos2.left < pos1.right + pos1.width;
      const sameColumn = pos1.left === pos2.left;

      const rowAbove = pos2.bottom < pos1.top && pos2.bottom > pos1.top - pos1.height;
      const rowSame = pos1.top === pos2.top;
      const rowBelow = pos2.top > pos1.bottom && pos2.top < pos1.bottom + pos1.height;
      
      return (leftNeighbour || sameColumn || rightNeighbour) && (rowAbove || rowSame || rowBelow);
    },

    strokeWidth() {
      if (this.partnership.partnershipType.includes("highRisk")) {
        return 7;
      }

      if (this.partnership.partnershipType.includes("lowRisk")) {
        return 3;
      }
      return 5;
    },

    strokeColour() {
      if (this.partnership.partnershipType.includes("Direct")) {
        return "#d62687";
      }

      if (this.partnership.partnershipType.includes("Overlapping")) {
        return "#dad12e";
      }

      if (this.partnership.partnershipCategory === PartnershipTypes.balanced) {
        return "#343ddb";
      }
      return "black";
    },

    pathD() {
      const start = this.partner1[0].$refs["icon-container"];
      const end = this.partner2[0].$refs["icon-container"];

      const startRect = start.getBoundingClientRect();
      const endRect = end.getBoundingClientRect();
      const containerRect = this.partner1[0].$el.parentElement.getBoundingClientRect();

      // Calculate the center points of the start and end elements
      var startX = startRect.left - containerRect.left + startRect.width / 2;
      var startY = startRect.top - containerRect.top + startRect.height / 2;
      var endX = endRect.left - containerRect.left + endRect.width / 2;
      var endY = endRect.top - containerRect.top + endRect.height / 2;

      // Calculate the distance between the start and end points
      var dx = endX - startX;
      var dy = endY - startY;
      var distance = Math.sqrt(dx*dx + dy*dy);
      
      // If the distance is less than or equal to 1.9 grid widths, draw a straight line
      if (distance <= (containerRect.width / 5) * 1.9) {
        return "M " + startX + " " + startY + " L " + endX + " " + endY;
      }
      // Otherwise, draw a curve
      // Calculate the control point for the curve
      var controlX = startX + dx / 2;
      var controlY = startY + dy / 2 - (distance / 3);

      return "M " + startX + " " + startY + " Q " + controlX + " " + controlY + " " + endX + " " + endY + " L " + endX + " " + endY;
    }
  },

  methods: {
    getPositionCentre(el) {
      return {
        x: el.offsetLeft + Math.round(el.offsetWidth / 2),
        y: el.offsetTop + Math.round(el.offsetHeight / 2)
      };
    },

    getPositionBox(el) {
      return {
        top: el.offsetTop,
        right: el.offsetLeft + el.offsetWidth,
        bottom: el.offsetTop + el.offsetHeight,
        left: el.offsetLeft,
        width: el.offsetWidth,
        height: el.offsetHeight,
      };
    }
  }
}
</script>
